<template>
  <Layout>
    <PageHeaderV2
      :title="title"
      :sub-title="subtitle"
    >
      <template #afterTitle>
        <McButton
          variant="secondary"
          icon="icon-outline_bell"
          :text="$t('cdmSecurityMonitoring.action.notificationHistory')"
          @click="handleClickNotificationHistory"
        />
      </template>
    </PageHeaderV2>
    <div>
      <b-tabs
        v-model="activeTab"
        nav-class="mc-tab-nav nav-flats"
        @input="onTabChange"
      >
        <b-tab
          v-for="tab in tabsList"
          :key="tab.id"
          :title="$t(tab.title)"
        >
          <component
            :is="tab.component"
            v-if="visitedTabs.includes(tab.id)"
            :key="getComponentKey(tab.id)"
          />
        </b-tab>
      </b-tabs>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeaderV2 from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'

import Dashboard from './tabs/Dashboard'
import DeviceStatus from './tabs/DeviceStatus'

import { CDM_ALERT_CODES } from './libs/constants'

import { GET_CATEGORY_BY_ID } from '@/services/api/setting/fleet/fleetCat'
import { NOTIFICATION_LIST_CODES } from '@/services/api/notification/general'

export default {
  page: {
    title: 'CDM Security Monitoring',
    meta: [{
      name: 'description',
      content: appConfig.description
    }],
  },
  components: {
    Layout,
    PageHeaderV2,
    McButton,
    Dashboard,
    DeviceStatus,
  },
  data() {
    const tabs = {
      'dashboard': {
        id: 0,
        slug: 'dashboard',
        title:'cdmSecurityMonitoring.tab.dashboard',
        component: Dashboard,
      },
      'device-status': {
        id: 1,
        slug: 'device-status',
        title: 'cdmSecurityMonitoring.tab.deviceStatus',
        component: DeviceStatus,
      },
    }

    const tabSlug = this.$route.query.tab
    const initialTab = tabs[tabSlug] ? tabs[tabSlug].id : 0

    return {
      alertCodes: null,
      vehicleCategory: null,

      activeTab: initialTab,
      visitedTabs: [initialTab],
      deviceStatusKey: 0,
      tabs,
      tabsByIdMap: Object.values(tabs).reduce((acc, tab) => {
        acc[tab.id] = tab
        return acc
      }, {})
    }
  },
  computed: {
    title() {
      return this.$t('cdmSecurityMonitoring.title')
    },
    subtitle() {
      return this.$t('cdmSecurityMonitoring.subtitle')
    },
    tabsList() {
      return Object.values(this.tabs)
    }
  },
  mounted() {
    if (!this.$route.query.tab) {
      const currentTab = this.tabsByIdMap[this.activeTab]
      this.$router.replace({
        query: { ...this.$route.query, tab: currentTab.slug }
      })
    }
  },
  methods: {
    getComponentKey(tabId) {
      return tabId === 1 ? `device-status-${this.deviceStatusKey}` : tabId
    },
    onTabChange(value) {
      // Force new DeviceStatus instance when leaving it
      if (this.activeTab === 1) {
        this.deviceStatusKey++
        this.visitedTabs = this.visitedTabs.filter(tabId => tabId !== 1)
      }

      if (!this.visitedTabs.includes(value)) {
        this.visitedTabs.push(value)
      }

      const tab = this.tabsByIdMap[value]
      if (tab) {
        this.$router.replace({
          query: { ...this.$route.query, tab: tab.slug }
        })
      }
    },
    async handleClickNotificationHistory() {
      if (!this.alertCodes) {
        const res = await this.$apollo.query({
          query: NOTIFICATION_LIST_CODES,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              alertCode: Object.values(CDM_ALERT_CODES),
            },
          },
        })

        if (res.error) {
          this.$mcToast.error(this.$t('global.somethingWentWrong'))
          return
        }

        this.alertCodes = res.data.alertCodes.alertCodes.map((alert) => {
          return {
            ...alert,
            key: alert.alertCode,
            label: alert.descriptionEng,
          }
        })
      }

      if (!this.vehicleCategory) {
        const res = await this.$apollo.query({
          query: GET_CATEGORY_BY_ID,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              category: "CDM",
            },
          },
        })

        if (res.error) {
          this.$mcToast.error(this.$t('global.somethingWentWrong'))
          return
        }

        this.vehicleCategory = res.data.vehicleCategory.vehicleCategory
      }

      localStorage.setItem('notification-filters', JSON.stringify([
        {
          key: 'vehicleCategory',
          values: ['CDM'],
        },
        {
          key: 'alertCode',
          values: Object.values(CDM_ALERT_CODES),
        }
      ]))

      localStorage.setItem('notification-full-objects', JSON.stringify({
        'vehicleCategory': [this.vehicleCategory],
        'alertCode': this.alertCodes
      }))

      window.open(this.$router.resolve({
        name: 'Notification Log',
      }).href, '_blank')
    }
  },
}
</script>
<style lang="scss" scoped>
:deep(.mc-tab-nav) {
  &.nav-flats .nav-link {
    border-color: transparent !important;
    background: transparent !important;
    
    &:hover:not(.active) {
      color: $blue;
    }
    
    &.active {
      color: $blue;
      border-bottom: 2px solid $blue !important;
    }
  }
  
  .nav-link.disabled {
    color: $teal-200 !important;
  }
}

:deep(.mc-datetime) {
  color: $mep-color-text-300 !important;
}
</style>